import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { anaBizApplicationListReducer } from './ana-biz-application-list.reducer';
import { ANA_BIZ_APPLICATION_LIST_STORE_NAME, AnaBizApplicationListState } from './ana-biz-application-list.state';

/** Token of the AnaBizApplicationList reducer */
export const ANA_BIZ_APPLICATION_LIST_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<AnaBizApplicationListState, Action>
>('Feature AnaBizApplicationList Reducer');

/** Provide default reducer for AnaBizApplicationList store */
export function getDefaultAnaBizApplicationListReducer() {
  return anaBizApplicationListReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(ANA_BIZ_APPLICATION_LIST_STORE_NAME, ANA_BIZ_APPLICATION_LIST_REDUCER_TOKEN)],
  providers: [{ provide: ANA_BIZ_APPLICATION_LIST_REDUCER_TOKEN, useFactory: getDefaultAnaBizApplicationListReducer }],
})
export class AnaBizApplicationListStoreModule {
  public static forRoot<T extends AnaBizApplicationListState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<AnaBizApplicationListStoreModule> {
    return {
      ngModule: AnaBizApplicationListStoreModule,
      providers: [{ provide: ANA_BIZ_APPLICATION_LIST_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
